<template>
    <div class="page">
        <div class="login-page">
            <div class="login-icon">
                <img :src="loadIcon" alt="Logo" />
            </div>
            <div class="login-title">
                <h3>{{ $t('app.name') }}</h3>
            </div>
            <LoginForm :old-login="isOldLogin" @data-login="login"></LoginForm>
        </div>
        <div class="mobile">
            <PortailMobile />
        </div>
    </div>
    <HomePageAuthenticationModale v-if="!isB2cAccountValid" />
    <WaitingModal v-if="registerMailLoading || authLoading" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoginForm from '@/modules/Login/components/LoginForm.vue';
import PortailMobile from '@/modules/Login/components/PortailMobile.vue';
import { AuthenticationParameters } from '@/modules/Auth/store/state';
import { store } from '@/plugins/store';
import { AuthAction } from '@/modules/Auth/store/actions-types';
import HomePageAuthenticationModale from '@/modules/Home/components/HomePageAuthenticationModale.vue';
import { AUTHENTICATION } from '@/store/mutation-types';
import { loginRequest, msalInstance, useMsalInstance } from '@/authenticationConfig';
import { AuthenticationResult } from '@azure/msal-browser';
import WaitingModal from '@/components/ui-components/WaitingModal.vue';

export default defineComponent({
    name: 'Login.vue',
    components: { WaitingModal, HomePageAuthenticationModale, LoginForm, PortailMobile },
    computed: {
        loadIcon() {
            return require('@/assets/img/logo.svg');
        },
        isB2cAccountValid() {
            return !this.$store.getters.getUser || this.$store.getters.getUser?.email_azure !== undefined;
        },
        isOldLogin() {
            return this.$store.getters.isOldLogin;
        },
        registerMailLoading() {
            return this.$store.getters.isRegisterMailLoading;
        },
        authLoading() {
            return this.$store.state.authState.isLoading;
        },
    },
    methods: {
        async login(data: AuthenticationParameters) {
            const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');

            localStorage.clear();

            if (redirectAfterLogin !== null) {
                localStorage.setItem('redirectAfterLogin', redirectAfterLogin);
            }

            let b2cPolicy: string;

            if (data.password != null && data.password.trim() !== '') {
                b2cPolicy = await store.dispatch(AuthAction.POST_LOGIN, data);
            } else {
                b2cPolicy = await store.dispatch(AuthAction.VERIFIER_LOGIN, data);
            }

            if (b2cPolicy) {
                await useMsalInstance(b2cPolicy);
                if (this.$store.getters.getUser?.email_azure !== undefined) {
                    await this.seConnecter();
                }
            }
        },

        async seConnecter(): Promise<void> {
            store.commit(
                `authenticationState/${AUTHENTICATION.SET_USER_MAIL}`,
                this.$store.getters.getUser?.email_azure
            );
            await this.signIn();
        },
        async signIn() {
            // On s'assure que le mode interactif est terminé
            await msalInstance
                .handleRedirectPromise()
                .then((token: AuthenticationResult | null) => {
                    console.info('[Guards] handleRedirectPromise ' + token);
                })
                .catch((error: string) => {
                    console.error(error);
                });

            const request = {
                ...loginRequest,
                loginHint: this.$store.getters['authenticationState/getUserEmail'].toLowerCase(), // Auto-complétion de l'e-mail dans la page Azure
                prompt: 'login', // Auto-complétion de l'e-mail dans la page Azure
            };

            this.$store.commit(`authenticationState/${AUTHENTICATION.SET_SIGN_IN_AZURE_CALLED}`, true);

            // Appel l'étape 1 de la connexion Microsoft
            console.info('[Guards] loginRedirect');
            msalInstance
                .loginRedirect(request)
                .then(() => {
                    console.info('[Guards] loginRedirect OK');
                    // Lorsqu'on est ici la page de connexion Microsoft est affichée, mais on n'est pas connecté,
                    // c'est le guards (acquireTokenSilent() en web, signInByCode() en mobile) qui connectera l'utilisateur dans un second temps
                })
                .catch((error: string) => {
                    console.info('[Guards] loginRedirect KO');
                    console.error(error);
                });
        },
    },
});
</script>

<style scoped>
.page {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.login-page {
    text-align: center;
}
.login-icon img {
    border: 1px solid var(--medium-light-grey);
    border-radius: 10px;
    width: 150px;
    height: 150px;
}
.login-title h3 {
    font-size: var(--font-size-high-medium);
    font-weight: var(--font-weight-normal);
    font-style: var(--font-style-normal);
    margin: 30px 0 20px 0;
    color: var(--color-principal);
}
.mobile {
    margin-top: 2vh;
}
@media screen and (max-height: 900px) {
    .login-icon img {
        width: 90px;
        height: 90px;
    }
    .login-title h3 {
        margin: 20px 0 10px 0;
    }
}
</style>
